// 栏目对应的id配置
const columns = {
    // 首页
    'index': 91,
    // 古往今来
    'about/historic': 67,
    // 四方上下
    'about/position': 68,
    // 历代祖师
    'about/former': 75,
    // 动态
    'news': 70,
    // 法迅法会
    'news/buddhism': 76,
    // 新闻通告
    'news/notice': 77,
    // 公益慈善
    'news/charitable': 78,
    // 净慈法务
    'fawu': 71,
    // 年度法会
    'fawu/fahui': 79,
    // 日常佛事
    'fawu/foshi': 80,
    // 广种福田
    'fawu/futian': 81,
    // 愿生安养
    'fawu/anyang': 82
}

// 获取栏目对应的id
function getColumnId (url) {
    return columns[url]
}

module.exports = {
    getColumnId
}